"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts `url` and `data` params to a valid GET URL with query parameters.
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#formatgeturlurl-data}
 */
function formatGetUrl(url, data) {
    if (data && Object.keys(data).length > 0) {
        var params = Object.keys(data)
            .map(function (key) { return encodeURIData(data, key); })
            .join('&')
            .replace(/%20/g, '+');
        return url + '?' + params;
    }
    else {
        return url;
    }
}
exports.default = formatGetUrl;
function encodeURIData(data, key) {
    if (Array.isArray(data[key]) && typeof data[key][0] !== 'object') {
        var array = data[key].map(function (element) {
            return encodeURIComponent(key) + '[]=' + encodeURIComponent(element);
        });
        return array.join('&');
    }
    if (typeof data[key] === 'object' || (Array.isArray(data[key]) && typeof data[key][0] === 'object')) {
        return encodeURIComponent(key) + '=' + JSON.stringify(data[key]);
    }
    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
}
